import{ScrollShadow as HeroUIScrollShadow}from"@heroui/react";export const ScrollShadow=HeroUIScrollShadow;